import { Model } from '@shared-features/models/model';
import { Expose, Type } from 'class-transformer';
import { ShipmentIntegrationActionLog } from '@features/shipments/models/shipment-integration-action-log.model';
import { ShipmentIntegrationActions } from '@shared-features/enums/shipment-integration-actions.enum';

export class ShipmentIntegrationAction extends Model {
  @Expose() action: ShipmentIntegrationActions;
  @Expose() totalSuccess: number;
  @Expose() totalFailed: number;

  @Expose()
  @Type(() => ShipmentIntegrationActionLog)
  logs: ShipmentIntegrationActionLog[];
}
